import { Link } from 'react-router-dom';
import { NavLinks } from './NavLinks';
import { UserMenu } from './UserMenu';
import { CartButton } from './CartButton';
import { SocialLinks } from './SocialLinks';

interface DesktopNavProps {
  isActive: (path: string) => boolean;
  user: any;
  signOut: () => Promise<void>;
  itemCount: number;
}

/** Desktop navigation bar with links, user menu, cart, and social icons */
export function DesktopNav({ isActive, user, signOut, itemCount }: DesktopNavProps) {
  return (
    <div className="hidden md:flex md:items-center space-x-6">
      <NavLinks isActive={isActive} />
      <div className="flex items-center space-x-6 ml-8">
        <UserMenu user={user} signOut={signOut} />
        <CartButton itemCount={itemCount} />
        <SocialLinks />
      </div>
    </div>
  );
}
